module.exports = __webpack_public_path__ + "assets/zhongyangjie.cb342b4f.svg";